import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

/**
 * @about Decide whether a call uses the route version that checks the warehouse ACL scopes.
 * The caller opts in with `isAclScoped`, and the new version applies only while
 * `AFS_WAREHOUSE_ACL_SCOPES` is on. Every other call keeps today's version.
 */
export const isWarehouseAclScoped = (queryArg: {isAclScoped?: boolean} | void) =>
  queryArg?.isAclScoped === true && isFeatureEnabled(featureFlags.AFS_WAREHOUSE_ACL_SCOPES);
